import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

function Root() {
  useASCIICode();
  return (
    <>
      <Outlet />
    </>
  );
}

export default Root;

function useASCIICode() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log(` 
                                                                                                                                                                                                                                          
      -,--.                     .----.,.                                 
      ,.....,--,...             .--,,,,.,,-                                
     ,-,,,,...,----,..  ..   ...,,...,,,,,-,                               
     -,,,,,,....,,,,,,.,-,...,,......,,-,,,,                               
    .-,,-,,,.......  .....,..........,,--,,,.                              
    ,-,--,,....           ..      ....,,-,,,,                              
    ,-,,,,.....    .    . ..       ....,,-,,-.                             
   .--,,,..... .         ....        ..,,,,,-.                             
   .---,,... ..  .      ......       ..,,,,,,.                             
   ,----,,......   ..   ......        ..,,,,,-.                            
  .----,,.............. ........       ..,,,,-,                            
  .----,,................,...... .     ..,,,,,-.                           
  .----,.................,,.......... ....,,,,,,                           
  -,,,,......,,,,,,,,,...,,,...............,,,,-                                                  
 .--,,,,,------~~------,,,--,,,,,,,........,,,,-                           
 ------,----~~~~~~----~-----,,,----,,,......,,,-                           
 --------~~:::::~~----~-----,,,--~~~-,,.....,,,-.                          
.------~-~:::;::::~-----,,,,,-~~~~~~~-,,...,,-,-.                          
-----~~~~~::;;:;=*;~,.......,-;*!~-~~~-,,..,,-,-.                          
----~~~~:::;;;!=@;=~.       .~$$@*:~~~-,,,,,,---,                          
~---~~:::::;;;=#@**,  .~::~. ,!=##*:~------,----.                          
---~~~:::::::;$@@*-..,;$**$:. ,;$==-~~-----,-----                          
,--~~::::::::~;=$:...;=#$$#!,  .:=-..,--,,,,-----                          
 -~~:::::~~-~~-~-....!##$$#=,.  .-,.   ....,,--~:-                         
 -~~:::~~----~--,,,,,~*###$!-......   .....,,--~::                         
 ,~::::~~-,,,,,,,,--~:!$$$$!-,....   .....,,---~:!                         
 .~:::~~~--,,,,---~~~:*$=$$*~,,,.,......,,,,---~:!                         
 .~::::~~~~-----~:::;;*$=$=*;~~-----,,,----,---~:!                         
  ~::::::::~~~::::;;**=##@$=*;:~:::~~-~~~------~~;                         
 .~::::::::::;;;;;;!=#@@@@@#$*!;!!!;;:::~~-----~~;                         
 .::::::::::;;;!!!!=$#@@@@@##$=*=*!!;;::~~~-----~:                         
  ::::::::;;;;!!*$#@#=$#@#=$@@@#=*!!!;;;:~-------~                         
  ~::::::;;;;;!!!*###=*!**!##@#=**!!!;;::~~~------                         
  ~::::::;;;;;;!!!*$###@$$###$***!!!!;;::~~~~-----                         
  ~::::::;;;;;;;!!;!*==$##$=!!!!!!!!;;::~~~~------                         
  -~::::::;;;;;;!!;;!!!*==*!;;!!!!!;;;:~~~~------,                         
  -:::::::;;;;;;;!;;;;;!!!!!!!!!!!!;::~~~-~~-~---.                         
  ,:::::::;;;;;;;;;;;;;;;;;;!!!!!!;;:~~~---~-~~--                          
  ,::~:::::;;;;;;;;!!;;;!!!!!!!!;;;:::~-----~~---                          
  ,:~~:~::::;;;;;;;;;;;;!!!!!!;;;;:::~~~-~~~~~--~                          
  .:~~~~~:::;;;;;;;;;;;;!!!!;;;:::~~~~~~~~-~~~---                          
                                                            

`);
    }
  });
}
